/**
 *  It was agreed with PD that we will only support a mobile viewport and a desktop viewport
 *  Mobile viewport is from 0 to 1199
 *  Desktop viewport is from 1200 to ∞
 *  (we do not support tablet viewport due to very low amount of customers that browse our platform on that viewport < 2%)
 *
 *  Furthermore:
 *  PD provides designs for mobile range using 360px screen (actual grid will be 328px wide)
 *  PD provides designs for desktop range using 1440px screen (actual grid is 1272px wide)
 * */
export default {
    values: {
        xs: 0,
        sm: 0,
        md: 1024,
        lg: 1024,
        xl: 1024,
    },
};
//# sourceMappingURL=breakpoints.js.map